import { useEffect } from "react";
import useScript from "@hooks/useScript";

const SDK_KEY = import.meta.env.VITE_SINGULAR_SDK_KEY;
const SDK_SECRET = import.meta.env.VITE_SINGULAR_SDK_SECRET;
const PRODUCT_ID = import.meta.env.VITE_SINGULAR_PRODUCT_ID;

export default function useSingularSDK() {
  const { isScriptReady } = useScript({
    id: "singular-sdk",
    src: "https://web-sdk-cdn.singular.net/singular-sdk/latest/singular-sdk.js",
    checkScriptIsLoaded: () => {
      return (
        typeof window.SingularConfig === "function" &&
        typeof window.singularSdk === "function"
      );
    },
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!isScriptReady) return;
    if (typeof SDK_KEY === "undefined") return;
    if (typeof SDK_SECRET === "undefined") return;
    if (typeof PRODUCT_ID === "undefined") return;

    try {
      const SingularConfig = window.SingularConfig;
      const config = new SingularConfig(SDK_KEY, SDK_SECRET, PRODUCT_ID);

      window.singularSdk.init(config);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Error setting for Singular SDK", e);
    }
  }, [isScriptReady]);
}
